import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';

import Form from 'antd/es/form';
import Input from 'antd/es/input';
import notification from 'antd/es/notification';
import Button from 'antd/es/button';
import Countdown from 'antd/lib/statistic/Countdown';
import './style.less';

import ArrowRightOutlined from '@ant-design/icons/ArrowRightOutlined';
import { LockIcon } from '../../../components/icon';
import { SendOTPByPhoneNow, SetNewPassword } from '../action';
import '../../../translations/i18n';
import Sidebar from '../../distributor/view/component/Sidebar/Sidebar';
import StickyTop from './profile/stickytop';

const ResetPassword = () => {
  const { t } = useTranslation();
  const location = useLocation();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  const [showOtp, setShowOtp] = useState(true);
  const [timer, setTimer] = useState(Date.now());

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const onFinish = async (value) => {
    if (value.password1 !== value.password2) {
      setLoader(false);
      notification.error({
        message: 'Error',
        description: t('passwordNotMatch'),
      });
      return;
    }
    value.phone_number = loginUser.phone_number;
    // console.log(value);
    const { message, error } = await SetNewPassword(value);
    if (error) {
      notification.error({
        message: error,
        description: message,
      });
    } else {
      // console.log(data);
      notification.success({
        message: t('success'),
      });
      navigate('/login');
    }
  };
  const sendOTPHandler = async () => {
    const { message, error, data } = await SendOTPByPhoneNow(
      location.state.phone_number,
    );
    if (error) {
      notification.error({
        message: error,
        description: message,
      });
    } else {
      setTimer(Date.now() + 60 * 1000);
      setShowOtp(false);
      notification.success({
        message: t('otpSent'),
      });
    }
  };

  // when timer over resend otp will show
  function onTimerOver() {
    setShowOtp(true);
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Sidebar />
      <div className='container newChange new' style={{ flex: 1 }}>
        <StickyTop />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <div className={'reg-container'}>
            <div
              className={'register register1'}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  marginTop: '3rem',
                }}
              >
                {/* <ScreenBack /> */}
                <div className={'humbee register-text'}>
                  {t('verify.resetPassword')}
                </div>
                <div className={'registerForm regform'}>
                  <Form
                    layout={'vertical'}
                    name='register'
                    onFinish={onFinish}
                    autoComplete='off'
                  >
                    <div
                      className={'otpContainer otpContainer-change_phoneNumber'}
                    >
                      <Form.Item
                        label={t('verify.oneTimePassword')}
                        name='otp'
                        rules={[
                          {
                            required: true,
                            message: 'OTP is required',
                          },
                        ]}
                      >
                        <Input
                          maxLength={4}
                          minLength={4}
                          placeholder={'OTP'}
                          inputMode={'numeric'}
                          onKeyPress={(e) => {
                            const key = e.key;
                            if (
                              (key !== '.' && isNaN(key)) ||
                              (key === '.' && e.target.value.includes('.'))
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>

                      {showOtp === false ? (
                        <div className='counter'>
                          <div className='counterTimer displayCenter'>
                            <div>
                              <p className='counter-text'>
                                {t('login.resendAfter')}
                              </p>
                            </div>
                            <div>
                              <Countdown
                                className={'loginCounter loginCounterRetailer'}
                                value={timer}
                                format='ss'
                                onFinish={onTimerOver}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={'resendText'}>
                          <p onClick={sendOTPHandler} className='send_otp'>
                            Send OTP
                          </p>
                        </div>
                      )}
                    </div>
                    <Form.Item
                      label={t('register.createPassword')}
                      name='password1'
                      rules={[
                        {
                          required: true,
                          message: t('register.noPassword'),
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password1').length >= 8 ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error(t('register.passwordLengthError')));
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        prefix={<LockIcon />}
                        placeholder={t('register.createPassword')}
                      />
                    </Form.Item>
                    <Form.Item
                      label={t('register.confirmPassword')}
                      name='password2'
                      rules={[
                        {
                          required: true,
                          message: t('register.noConfirmPassword'),
                        },
                      ]}
                    >
                      <Input.Password
                        prefix={<LockIcon />}
                        placeholder={t('register.passwordAgain')}
                      />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        loading={loader}
                        block={true}
                        type='primary'
                        htmlType='submit'
                        className={'btn'}
                      >
                        <b className={'btnText'}>{t('verify.resetPassword')}</b>
                        <ArrowRightOutlined className={'btnArrow'} />
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
